import { C } from 'jssip'

export const SEND_DTMF_OPTIONS = {
  transportType: C.DTMF_TRANSPORT.RFC2833,
}

export const SEND_DTMF_INTERTONE_GAP = {
  cs2: 500,
  cs3: 100,
}

export const DIALPAD_MAP = {
  '1': '',
  '2': 'abc',
  '3': 'def',
  '4': 'ghi',
  '5': 'jkl',
  '6': 'mno',
  '7': 'pqrs',
  '8': 'tuv',
  '9': 'wxyz',
  '*': '',
  '0': '+',
  '#': '',
}

export const KEYS = [
  ['1', '2', '3'],
  ['4', '5', '6'],
  ['7', '8', '9'],
  ['*', '0', '#'],
]

const map = {}

Object.keys(DIALPAD_MAP).forEach((number) => {
  // add keys to map
  map[number] = number
  const letters = DIALPAD_MAP[number].split('')
  // spread values in to map
  if (letters.length) {
    letters.forEach((letter) => {
      map[letter] = number
    })
  }
})

export const CHARACTER_MAP = map
